import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo/logo_header.png";

export default function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-white via-cream to-gray-50">
      <div className="bg-maroon text-white py-5 shadow-md">
        <div className="max-w-5xl mx-auto px-5 md:px-10 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group min-w-0">
            <img
              src={logo}
              alt="Shivkumar Jewellers"
              className="h-10 w-10 sm:h-12 sm:w-12 object-contain flex-shrink-0"
            />
            <span className="font-serif font-bold text-gold group-hover:text-gold-light transition-colors text-sm md:text-base truncate">
              Shivkumar Jewellers
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-xs md:text-sm border border-gold/40 text-gold hover:bg-gold hover:text-maroon px-4 py-2 rounded-full transition-colors flex-shrink-0"
          >
             Back to Home
          </Link>
        </div>
      </div>

      <div className="max-w-5xl mx-auto px-5 md:px-10 py-10 md:py-16">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.35em] text-gold-dark font-semibold mb-3">
            <span className="h-px w-8 bg-gold" />
            Legal
            <span className="h-px w-8 bg-gold" />
          </span>
          <h1 className="font-serif text-3xl md:text-5xl text-maroon font-bold">
            Terms & Conditions
          </h1>
          <p className="mt-3 text-sm text-gray-600">
             2026 Copyright SHIVKUMAR JEWELLERS. All rights reserved.
          </p>
        </div>

        <article className="bg-white rounded-2xl shadow-lg border border-gold/20 p-6 md:p-10 space-y-6 text-gray-700 leading-relaxed text-[15px]">
          <div className="p-4 bg-cream rounded-xl border-l-4 border-gold">
            <h2 className="font-serif text-lg md:text-xl text-maroon font-bold mb-2">
              Official Website Legal Notice
            </h2>
            <p className="text-sm">
               2026 Copyright{" "}
              <strong className="text-maroon">SHIVKUMAR JEWELLERS</strong>.
              All rights reserved. Reproduction, adaptation, or translation
              without permission is prohibited except as allowed under the
              International copyright laws. All the text, graphics, design,
              content, and other works are the copyrighted works of SHIVKUMAR
              JEWELLERS.
            </p>
          </div>

          <Section title="Terms and Conditions of Use">
            <p>
              Welcome to the corporate/official website of{" "}
              <strong className="text-maroon">SHIVKUMAR JEWELLERS</strong>{" "}
              (
              <a
                href="https://shivkumarjewellers.com/"
                className="text-gold-dark hover:underline"
              >
                https://shivkumarjewellers.com/
              </a>
              ). Use of this site is governed by the Terms and Conditions set
              forth.{" "}
              <strong>
                PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE USING
                THIS WEBSITE.
              </strong>
            </p>
            <p>
              The information and materials provided by SHIVKUMAR JEWELLERS
              may be used for informational purposes only. By using, accessing
              or downloading materials from this website you agree to follow
              the terms and provisions as outlined in this legal notice, which
              apply to all visits to the SHIVKUMAR JEWELLERS website, both now
              and in the future.
            </p>
            <p>
              SHIVKUMAR JEWELLERS may at any time revise and update the Terms
              and Conditions. You are encouraged to periodically visit this
              page to review the most current Terms and Conditions to which
              you are bound. If you do not agree to these Terms and Conditions
              of Use, please do not use this website.
            </p>
          </Section>

          <Section title="Restrictions">
            <p>
              You may view, download and copy information and materials
              available on this website solely for your personal,
              non-commercial use. You may also use such material within your
              organization in connection with the support of SHIVKUMAR
              JEWELLERS's products. As a condition of use, you agree not to
              modify or revise any of the material in any manner, and to
              retain all copyright and other proprietary notices as contained
              in the original materials on any copies of the materials. No
              other use of the materials or information is authorized. Any
              violation of the foregoing may result in civil and/or criminal
              liabilities.
            </p>
          </Section>

          <Section title="Ownership of Information and Materials">
            <p>
              The information and any materials (including white papers, press
              releases, data sheets, product descriptions, and FAQs) available
              on or from this website are the copyrighted works of SHIVKUMAR
              JEWELLERS, and any unauthorized use of that information or
              materials may violate copyright, trademark and other laws. Any
              rights not expressly granted herein are reserved.
            </p>
          </Section>

          <Section title="Trademark Information">
            <p>
              SHIVKUMAR JEWELLERS's trademarks may be used only with written
              permission from SHIVKUMAR JEWELLERS. SHIVKUMAR JEWELLERS, [SMS
              GOLD], and all associated product and brand names are registered
              trademarks or trademarks of SHIVKUMAR JEWELLERS. All other
              trademarks, brands, and names are the property of their
              respective owners. Except as expressly specified in these terms
              and legal restrictions, nothing contained herein shall be
              construed as conferring by implication, estoppel or otherwise
              any license or right under any patent, trademark, copyright or
              any proprietary rights of SHIVKUMAR JEWELLERS or any third
              party.
            </p>
          </Section>

          <Section title="Links to Other Websites">
            <p>
              As a convenience and to make the SHIVKUMAR JEWELLERS website
              truly service oriented we have included links to complementary
              sites on the Internet. These sites are owned and operated by
              third parties. SHIVKUMAR JEWELLERS makes no representation and
              is not responsible for the availability of, or content located
              on or through, these third party sites. A third party link from
              the SHIVKUMAR JEWELLERS website is not an indication that
              SHIVKUMAR JEWELLERS endorses the third party or its site, or has
              any affiliation with or between SHIVKUMAR JEWELLERS and the
              third party hosting site.
            </p>
          </Section>

          <Section title="Feedback">
            <p>
              All comments, feedback, information or materials submitted to
              SHIVKUMAR JEWELLERS through or in association with this website
              shall be considered non-confidential and SHIVKUMAR JEWELLERS's
              property. By submitting such comments, information, feedback, or
              materials to SHIVKUMAR JEWELLERS, you agree to a no-charge
              assignment to SHIVKUMAR JEWELLERS of worldwide rights to use,
              copy, modify, display and distribute the submissions. SHIVKUMAR
              JEWELLERS may use such comments, information or materials in any
              way it chooses on an unrestricted basis.
            </p>
          </Section>

          <Section title="Disclaimer">
            <p>
              The SHIVKUMAR JEWELLERS Internet team strives to provide you
              with useful, accurate, and timely information on this website.
              Accordingly, SHIVKUMAR JEWELLERS has attempted to provide
              accurate information and materials on this website but assumes
              no responsibility for the accuracy and completeness of that
              information or materials. SHIVKUMAR JEWELLERS may change the
              content of any information or materials available at this
              website, or to the products described in them, at any time
              without notice. However, SHIVKUMAR JEWELLERS makes no commitment
              to update the information or materials on this website which, as
              a result, may be out of date. Information and opinions expressed
              in bulletin boards or other forums are not necessarily those of
              SHIVKUMAR JEWELLERS. Neither SHIVKUMAR JEWELLERS, nor its
              officers, directors, employees, agents, distributors, or
              affiliates are responsible or liable for any loss or damage
              (including, but not limited to, actual, consequential, or
              punitive), liability, claim, or other injury or cause related to
              or resulting from any information posted on SHIVKUMAR
              JEWELLERS's website. SHIVKUMAR JEWELLERS reserves the right to
              revise these terms and/or legal restrictions at any time.
            </p>
            <p className="text-sm font-medium text-maroon/80 bg-cream p-4 rounded-xl border border-gold/30">
              ALL INFORMATION AND MATERIALS AVAILABLE AT THIS WEBSITE ARE
              PROVIDED "AS IS" WITHOUT ANY WARRANTIES OF ANY KIND, EITHER
              EXPRESS OR IMPLIED, AND SHIVKUMAR JEWELLERS DISCLAIMS ALL
              WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING
              WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE,
              NON-INFRINGEMENT OF INTELLECTUAL PROPERTY OR ARISING FROM A
              COURSE OF DEALING, USAGE OR TRADE PRACTICE. IN NO EVENT SHALL
              SHIVKUMAR JEWELLERS BE LIABLE FOR ANY DAMAGES WHATSOEVER
              (INCLUDING, WITHOUT LIMITATION, INDIRECT, SPECIAL, CONSEQUENTIAL
              OR INCIDENTAL DAMAGES OR THOSE RESULTING FROM LOST PROFITS, LOST
              DATA OR BUSINESS INTERRUPTION) ARISING OUT OF THE USE,
              INABILITY TO USE, OR THE RESULTS OF USE OF THIS WEBSITE, ANY
              WEBSITES LINKED TO THIS WEBSITE, OR THE MATERIALS OR INFORMATION
              CONTAINED AT ANY OR ALL SUCH WEBSITES, WHETHER BASED ON
              WARRANTY, CONTRACT, TORT OR ANY OTHER LEGAL THEORY AND WHETHER
              OR NOT ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
            </p>
          </Section>

          <Section title="Termination of Use">
            <p>
              SHIVKUMAR JEWELLERS may, in its sole discretion, terminate or
              suspend your access to all or part of the SHIVKUMAR JEWELLERS
              website, including, but not limited to any bulletin boards on
              its site, for any reason, including without limitation, breach
              of this agreement. In the event this agreement is terminated,
              the restrictions regarding materials appearing on the site and
              the representations and warranties, indemnities, and limitation
              of liabilities set forth in this agreement shall survive any
              such termination.
            </p>
          </Section>

          <Section title="Governing Law; Jurisdiction and Venue">
            <p>
              This Agreement shall be governed by and construed in accordance
              with the laws of the State of Gujarat, INDIA. The Gujarat courts
              shall have exclusive jurisdiction and venue over any dispute
              arising out of or relating to this Agreement, and each party
              hereby consents to the jurisdiction and venue of such courts.
            </p>
          </Section>

          <Section title="General Provisions">
            <p>
              If any provision of this agreement is deemed void, unlawful or
              otherwise unenforceable for any reason, that provision shall be
              severed from this agreement and the remaining provisions of this
              agreement shall remain in force. This contains the entire
              agreement between you and SHIVKUMAR JEWELLERS concerning your
              use of the site, and the agreement shall not be modified, except
              in writing, signed by both parties.
            </p>
          </Section>

          <Section title="Contact Us">
            <p>
              If you have questions regarding SHIVKUMAR JEWELLERS's Terms and
              Conditions, please contact us:
            </p>
            <div className="mt-4 p-4 bg-cream rounded-xl border border-gold/30 space-y-1">
              <p className="text-sm">
                <strong className="text-maroon">Email:</strong>{" "}
                <a
                  href="mailto:smsgold.vs@gmail.com"
                  className="text-gold-dark hover:underline"
                >
                  smsgold.vs@gmail.com
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Mobile:</strong>{" "}
                <a
                  href="tel:+919898313040"
                  className="text-gold-dark hover:underline"
                >
                  +91 98983 13040
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Enquiry:</strong>{" "}
                <a
                  href="tel:+919798993336"
                  className="text-gold-dark hover:underline"
                >
                  +91 97989 93336
                </a>
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Address:</strong> Shivkumar
                Jewellers, 5/4/56, 57, 58 Swaminarayan Mandir No Kancho, Lal
                Darwaja, Visnagar, Gujarat  384315
              </p>
              <p className="text-sm">
                <strong className="text-maroon">Website:</strong>{" "}
                <a
                  href="https://shivkumarjewellers.com"
                  className="text-gold-dark hover:underline"
                >
                  shivkumarjewellers.com
                </a>
              </p>
            </div>
          </Section>
        </article>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="font-serif text-xl md:text-2xl text-maroon font-bold mb-3 pb-2 border-b-2 border-gold/30">
        {title}
      </h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </div>
  );
}
